import { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '~hooks/index';
import { selectAuth } from '~store/slices/auth';
import { PATHS } from '~constants/index';

import ComponentWithSuspense from '../ComponentWithSuspense';

interface AuthRouteProps {
  component: ReactNode;
}

const AuthRoute = ({ component }: AuthRouteProps): ReactElement => {
  const { token, user } = useAppSelector(selectAuth);

  if (!!token && !!user) {
    return <Navigate to={PATHS.HOME.BASE} replace />;
  }

  return <ComponentWithSuspense component={component} />;
};

export default AuthRoute;
